module.exports = __webpack_public_path__ + "Poppins-Regular.976682340b5b3d63bbd2.svg";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2/src/assets/fonts/Poppins-Regular.svg
// module id = ../../../../../src/assets/fonts/Poppins-Regular.svg
// module chunks = main